import styled from 'styled-components';
import SistemaList from '~/pages/Sistema/componentes/SistemaList';

export const Main = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
`;

export const LandPage = styled.div`
  width: calc(100%) !important;

  .content {
    display: flex;
    flex-direction: column;
    height: 100%;

    .container-pj {
      height: 100%;
      padding: 0 1rem;
    }
  }
`;

export const Container = styled(SistemaList)``;